import { AbstractControl, FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export const StartDateBeforeEndDate = (control: AbstractControl): {[key: string]: boolean} => {
    const startDateControl = control.get('startDateControl');
    const endDateControl = control.get('endDateControl');

    if (startDateControl && endDateControl && startDateControl.value && endDateControl.value) {
        const startDate = new Date(startDateControl.value);
        const endDate = new Date(endDateControl.value);

        return (endDate > startDate) ? null : {'endDateLessThanStartDate': true};
    }

    return null;
}


/**
 * Custom ErrorStateMatcher which returns true (error exists) when the parent form group is invalid and the control has been touched
 */
export class StartEndDateValidParentMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return control.parent.invalid && control.touched;
    }
}
